















































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { DateTime } from 'luxon'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { Medico } from '@/types/_'
import moment from 'moment'
import { VAlert } from 'vuetify/lib'
import { stringToDecimal, onlyNumber } from '@/utils/common'

@Component

export default class ComponentRemuneracaoRightNavBar extends Vue {
    $refs: {
    menu: any,
    menuAte: any,
  }

  menu: boolean = false
  menuAte: boolean = false
  fltLoading: boolean = false

  get numeroAtendimento() {
    return this.getStore.numeroAtendimento
  }

  set numeroAtendimento(value: string) {
    this.getStore.setNumeroAtendimento(value)
  }

  get codigoItens() {
    return this.getStore.codigoItens
  }

  set codigoItens(value: string) {
    this.getStore.setCodigoItens(value)
  }

  get getTipoItens() {
    return this.getStore.tipoItensList
  }

  get getProfissionais() {
    return this.getStore.allProfissionaisList
  }

  get getConvenios() {
    return this.getStore.conveniosList
  }

  get anoMesReferenciaDe() {
    return this.getStore.anoMesReferenciaDe
  }

  set anoMesReferenciaDe(value) {
    this.getStore.setAnoMesReferenciaDe(value)
  }

  get anoMesReferenciaAte() {
    return this.getStore.anoMesReferenciaAte
  }

  set anoMesReferenciaAte(value) {
    this.getStore.setAnoMesReferenciaAte(value)
  }

  get profissionais() {
    return this.getStore.profissionais || this.getStore.selectedProfissionalExecutante
  }

  set profissionais(value) {
    this.getStore.setProfissionais(value)
    this.getStore.setSelectedProfissionalExecutante(value || '')
  }

  get convenios() {
    return this.getStore.convenios
  }

  set convenios(value) {
    this.getStore.setConvenios(value)
  }

  get tipoItens() {
    return this.getStore.tipoItens
  }

  set tipoItens(value: string) {
    this.getStore.setTipoItens(value)
  }

  get somatorioTotalNotas() {
    return this.getStore.somatorioTotalNotas
  }

  set somatorioTotalNotas(value: number) {
    this.getStore.setSomatorioTotalNotas(value)
  }

  get periodosList() {
    return this.getStore.periodos
  }

  get selectedPeriodo() {
    return this.getStore.selectedPeriodo
  }

  set selectedPeriodo(value) {
    this.getStore.setSelectedPeriodo(value)
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get drawer() {
    return this.getStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setFilterDrawer(value)
  }

  get getMenu() {
    return this.menu
  }

  set getMenu(value: boolean) {
    this.menu = value
  }

  get getMenuAte() {
    return this.menuAte
  }

  set getMenuAte(value: boolean) {
    this.menuAte = value
  }

  get loadingTipoItens() {
    return this.getStore.loadingTipoItens
  }

  get loadingProfissionais() {
    return this.getStore.loadingProfissionais
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async search() {
    this.filterLoading = true
    this.getStore.setPagina(1)
    if(this.profissionais){
      this.getStore.setSelectedProfissionalExecutante(this.profissionais)
    }
    const id = this.getStore.idForLoadItensRepasse
    await this.getStore.getGeracaoDeRepasseItensPrestador(id)
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return this.getStore.numeroAtendimento !== ''
      || this.getStore.tipoItens !== ''
      || this.getStore.codigoItens !== ''
      || this.getStore.anoMesReferenciaDe !== ''
      || this.getStore.anoMesReferenciaAte !== ''
      || this.getStore.profissionais !== ''
      || this.getStore.convenios !== ''
  }

  async clear() {
    this.getStore.clearAdvancedFilters()
    await this.search()
    this.getStore.setFilterOn(false)
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
